module.exports = __webpack_public_path__ + "static/Logo_K_grau-dbaef07ddce848b483bcf2711b1c7388.png";